export enum AdviceSectionTypes {
    SELECTION_ADVICE = "selectionAdvice",
    DEVELOPMENT_ADVICE = "developmentAdvice",
    SELECTION_DEVELOPMENT_ADVICE = "selectionDevelopmentAdvice",
}
